import { alphaSort } from 'vet-bones/utils';

const propertiesSort = alphaSort((item: [string, any]) => item[0]);

export const stringifyProperties = (
  properties: Record<string, string | boolean | number>
) =>
  Object.entries(properties)
    .sort(propertiesSort)
    .filter(([_, value]) => value !== '')
    .map(([key, value]) => `${key}=${value}`)
    .join('\n');
